export enum CourseContractStatus {
  Signed = "signed",
  Failed = "failed",
  DownloadFailed = "download_failed",
  NotSent = "not_sent",
  SentButNotSigned = "sent_but_not_signed",
  Downloaded = "downloaded",
}
